module.exports = __webpack_public_path__ + "img/3-3-2.113b5cc2.png";